import React from 'react';
import type { HeadingProps } from '@usewaypoint/block-heading';
import { useCurrentBlockId } from '../../editor/EditorBlock';
import { useSelectedBlockId, setDocument, useDocument } from '../../editor/EditorContext';
import HeadingWithPlaceholders from './HeadingWithPlaceholders';
import InlineHeadingEditor from './InlineHeadingEditor';

/**
 * Smart Heading component that switches between read-only and editable modes
 * - When selected: Renders TipTap editor for inline editing
 * - When not selected: Renders read-only HeadingWithPlaceholders
 */
export default function EditableHeading(props: HeadingProps) {
  const blockId = useCurrentBlockId();
  const selectedBlockId = useSelectedBlockId();
  const document = useDocument();
  const isSelected = selectedBlockId === blockId;

  const handleSave = (markdown: string, level: 'h1' | 'h2' | 'h3') => {
    // Update the block's text content and level in Zustand when user blurs
    const currentBlock = document[blockId];
    if (currentBlock && currentBlock.type === 'Heading') {
      setDocument({
        [blockId]: {
          ...currentBlock,
          data: {
            ...currentBlock.data,
            props: {
              ...currentBlock.data.props,
              text: markdown,
              level,
            },
          },
        },
      });
    }
  };

  // When selected, render editable TipTap editor
  if (isSelected) {
    return (
      <InlineHeadingEditor
        initialContent={props.props?.text || ''}
        onSave={handleSave}
        blockId={blockId}
        style={props.style}
        level={props.props?.level || 'h2'}
      />
    );
  }

  // When not selected, render read-only preview
  return <HeadingWithPlaceholders {...props} />;
}
